import { Icon as IconifyIcon } from "@iconify/react"
import { cn } from "@/lib/utils"

type IconProps = {
  icon: string
} & React.ComponentPropsWithoutRef<typeof IconifyIcon>

export function Icon({ icon, className, ...props }: IconProps) {
  return <IconifyIcon icon={icon} className={cn("", className)} {...props} />
}
